import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, Optional, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Subject, BehaviorSubject } from 'rxjs';
import { defaultModuleConfig, PageTitlesModuleConfigToken } from '@mt-ng2/page-titles-config';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
class PageTitlesService {
    constructor(titleService, moduleConfig) {
        this.titleService = titleService;
        this.moduleConfig = moduleConfig;
        this._setPageTitleCalled = new Subject();
        /**
         * Observable emitting the value passed in to setPageTitle whenever it is called.
         * This is the value prior to the TitleTextFormatFunction being called.  (i.e. if
         * setPageTitle was called with 'Customers' and the TitleTextFormatFunction would return
         * 'Breck - Customers' this value would be the original 'Customers')
         */
        this.setPageTitleCalled = this._setPageTitleCalled.asObservable();
        this._pageTitleSet = new BehaviorSubject(null);
        /**
         * Observable emitting the value when the page title changes after having called
         * setPageTitle.  This is the value after the TitleTextFormatFunction has been called.
         * (i.e. if setPageTitle was called with 'Customers' and the TitleTextFormatFunction
         * would return 'Breck - Customers' this value would be formmated value of
         * 'Breck - Customers')
         */
        this.pageTitleSet = this._pageTitleSet.asObservable();
        this.setModuleConfig(moduleConfig);
    }
    /**
     * The page title currently set in the browser tab
     */
    get currentPageTitle() {
        return this._pageTitleSet.getValue();
    }
    setModuleConfig(moduleConfig) {
        if (!moduleConfig) {
            moduleConfig = {};
        }
        this.moduleConfig = Object.assign(defaultModuleConfig, moduleConfig);
    }
    /**
     * This function sets the page title to the browser tab.  It will run the
     * TitleTextFormatFunction on the title parameter prior to setting it.
     * @param {string} title - the title to set.
     */
    setPageTitle(title) {
        if (this.moduleConfig && this.moduleConfig.ignorePageTitleCalls) {
            return;
        }
        // emit that we received a title
        this._setPageTitleCalled.next(title);
        // get any title text format function from the config
        const titleTextFormatFunction = (this.moduleConfig && this.moduleConfig.titleTextFormatFunction) || null;
        // if we have a title text format function, then call it
        const formattedTitle = titleTextFormatFunction ? titleTextFormatFunction(title) : title;
        // set the page title
        this.titleService.setTitle(formattedTitle);
        // emit the final page title
        this._pageTitleSet.next(formattedTitle);
    }
}
PageTitlesService.ɵfac = function PageTitlesService_Factory(t) { return new (t || PageTitlesService)(ɵngcc0.ɵɵinject(ɵngcc1.Title), ɵngcc0.ɵɵinject(PageTitlesModuleConfigToken, 8)); };
PageTitlesService.ɵprov = ɵɵdefineInjectable({ factory: function PageTitlesService_Factory() { return new PageTitlesService(ɵɵinject(Title), ɵɵinject(PageTitlesModuleConfigToken, 8)); }, token: PageTitlesService, providedIn: "root" });
PageTitlesService.ctorParameters = () => [
    { type: Title },
    { type: undefined, decorators: [{ type: Inject, args: [PageTitlesModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageTitlesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Title }, { type: undefined, decorators: [{
                type: Inject,
                args: [PageTitlesModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

class PageTitleComponent {
    constructor(pageTitlesService) {
        this.pageTitlesService = pageTitlesService;
    }
    ngOnChanges(changes) {
        // if the changes include changes to the pageTitle property
        if (changes.pageTitle) {
            // and if there is a value
            if (this.pageTitle) {
                // then call the setPageTitle meothod
                this.pageTitlesService.setPageTitle(this.pageTitle);
            }
        }
    }
}
PageTitleComponent.ɵfac = function PageTitleComponent_Factory(t) { return new (t || PageTitleComponent)(ɵngcc0.ɵɵdirectiveInject(PageTitlesService)); };
PageTitleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PageTitleComponent, selectors: [["mt-page-title"]], inputs: { pageTitle: "pageTitle" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, template: function PageTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate1("\n        ", ctx.pageTitle, "\n    ");
    } }, encapsulation: 2, changeDetection: 0 });
PageTitleComponent.ctorParameters = () => [
    { type: PageTitlesService }
];
PageTitleComponent.propDecorators = {
    pageTitle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageTitleComponent, [{
        type: Component,
        args: [{
                // OnPush ensures only changes in @Input properties cause change detection to run
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'mt-page-title',
                template: `
        {{ pageTitle }}
    `
            }]
    }], function () { return [{ type: PageTitlesService }]; }, { pageTitle: [{
            type: Input
        }] }); })();

/**
 * This module is responsible for setting page titles to the browser tab.  It allows
 * for customization of the string prior to setting the tab (i.e. prefixing all titles
 * with something like 'Breck - Customers'), and provides event hooks for page title
 * setting.  There is also a page title component, which takes care of calling the
 * PageTitlesService on any change in the title.
 */
class PageTitlesModule {
}
PageTitlesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PageTitlesModule });
PageTitlesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PageTitlesModule_Factory(t) { return new (t || PageTitlesModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PageTitlesModule, { declarations: function () { return [PageTitleComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PageTitleComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PageTitlesModule, [{
        type: NgModule,
        args: [{
                declarations: [PageTitleComponent],
                exports: [PageTitleComponent],
                imports: [CommonModule]
            }]
    }], null, null); })();

// module

/**
 * Generated bundle index. Do not edit.
 */

export { PageTitleComponent, PageTitlesModule, PageTitlesService };

//# sourceMappingURL=mt-ng2-page-titles.js.map